import { WhatsApp } from 'constants/messageMediums';
import { getTemplateTypeLabel } from 'modules/campaigns/lib/utils/template';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useTemplateQueryContext } from 'modules/templateEditor/context/TemplateQueryContext';
import { TemplateDetailsBlock } from './EditableHeader.styled';

export const SubHeaderWhatsAppType = () => {
  const { liveTemplate } = useEditableFieldsContext();
  const { medium } = useTemplateQueryContext();
  const isWhatsApp = medium === WhatsApp;

  const whatsAppTemplateType = liveTemplate?.templateType;

  return isWhatsApp && whatsAppTemplateType ? (
    <TemplateDetailsBlock>{getTemplateTypeLabel(whatsAppTemplateType)}</TemplateDetailsBlock>
  ) : null;
};
